import { useState, useEffect } from 'react';

const STORAGE_KEY = 'baselmitkindern_article_favorites';

let _favorites = [];
const _listeners = new Set();

try {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) _favorites = JSON.parse(stored);
} catch (e) {}

function notify() {
  _listeners.forEach(fn => fn([..._favorites]));
}

function setFavorites(newFavs) {
  _favorites = newFavs;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(_favorites));
  window.dispatchEvent(new CustomEvent('articleFavoritesUpdated', { detail: { count: _favorites.length } }));
  notify();
}

export function useArticleFavorites() {
  const [favorites, setLocalFavorites] = useState([..._favorites]);

  useEffect(() => {
    const listener = (favs) => setLocalFavorites(favs);
    _listeners.add(listener);
    setLocalFavorites([..._favorites]);
    return () => _listeners.delete(listener);
  }, []);

  const toggleFavorite = (articleId) => {
    if (_favorites.includes(articleId)) {
      setFavorites(_favorites.filter(id => id !== articleId));
    } else {
      setFavorites([..._favorites, articleId]);
    }
  };

  const isFavorite = (articleId) => favorites.includes(articleId);

  return { favorites, toggleFavorite, isFavorite, isLoaded: true };
}

export default useArticleFavorites;